<template>
  <div>
    <b-row>
      <b-col>
        <div class="btn-toolbar mb-3" role="toolbar">
          <div class="btn-group" role="group">
            <button type="button" class="btn btn-secondary" v-on:click="Edit()" title="Ändra"
              v-if="!readonly && !editMode">
              <!-- <i class="fa fa-edit fa-xs mt-4"></i> -->
              <b-icon-pencil-square />
              Ändra
            </button>
            <button type="button" class="btn btn-primary" v-on:click="Save()" title="Spara ändringar " v-if="editMode">
              Spara
            </button>
            <button type="button" class="btn btn-primary" v-on:click="CancelEdit()" title="Avbryt förändringarna"
              v-if="editMode">
              Avbryt
            </button>
          </div>

          &nbsp;
        </div>
      </b-col>
      <b-col>
        <div class="btn-group" role="group">
          <button type="button" class="btn btn-secondary" v-on:click="SetPwd()" title="Sätt lösenord"
            v-if="!readonly && !editMode" right>
            <!-- <i class="fa fa-edit fa-xs mt-4"></i> -->
            <b-icon-x-circle></b-icon-x-circle>
            Sätt lösenord
          </button>
        </div>
      </b-col>
      <b-col>
        <div class="btn-group" role="group">
          <button type="button" class="btn btn-secondary" v-on:click="RemoveUser()" title="Ta bort"
            v-if="!readonly && !editMode" right>
            <!-- <i class="fa fa-edit fa-xs mt-4"></i> -->
            <b-icon-x-circle></b-icon-x-circle>
            Ta bort
          </button>
        </div>
      </b-col>
    </b-row>

    <b-card>
      <b-card-body v-if="au" class="scroll">
        <b-row>
          <b-col>
            <label>Användarnamn:</label>
          </b-col>
          <b-col>
            {{ au.username }}
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <label>Förnamn:</label>
          </b-col>
          <b-col>
            <div v-if="!editMode">{{ au.firstname }}</div>
            <b-input v-model="au.firstname" v-if="editMode"></b-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <label>Efternamn:</label>
          </b-col>
          <b-col>
            <div v-if="!editMode">{{ au.lastname }}</div>
            <b-input v-model="au.lastname" v-if="editMode"></b-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <label>E-post:</label>
          </b-col>
          <b-col>
            <div v-if="!editMode">{{ au.email }}</div>
            <b-input v-model="au.email" v-if="editMode"></b-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <label>Telefon:</label>
          </b-col>
          <b-col>
            <div v-if="!editMode">{{ au.phone }}</div>
            <b-input v-model="au.phone" v-if="editMode"></b-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <label>Låsning:</label>
          </b-col>
          <b-col>
            <b-row>
              <b-col v-if="editMode">
                <b-checkbox v-model="au.locked"></b-checkbox>
              </b-col>
              <b-col>
                <div v-if="au.locked">
                  <b-icon-lock-fill variant="danger"></b-icon-lock-fill>&nbsp;<b>Låst</b>
                </div>
                <div v-if="!au.locked">
                  <b-icon-unlock variant="success"></b-icon-unlock>&nbsp;Upplåst
                </div>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row>
          <b-col><label>Terminaler:</label></b-col>
          <b-col>  
            <!-- terms:{{ au.terminalIds }}           -->
            <userterminal v-model="au.terminalIds" :readonly="!editMode"></userterminal>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-card>
              <!-- <b-card-title>Behörighet:</b-card-title> -->
              <b-card-body>
                <b-row>
                  <b-col cols="6">
                    <label>Tilldelad behörighet:</label>
                    <b-row v-for="p in au.permissions" :key="p.PermissionId">
                      <b-col cols="10">
                        <b-icon-key></b-icon-key>
                        {{ GetPermissionText(p) }}
                      </b-col>
                      <b-col>
                        <b-icon-x-circle-fill title="Ta bort behörighet" v-if="editMode && MayGrant(p)"
                          @click="RemovePermission(p)"></b-icon-x-circle-fill>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col v-if="editMode">
                    <label>Tillgänglig behörighet:</label>
                    <b-row v-for="p in GetPossiblePermissions()" :key="p.PermissionId" @click="AddPermission(p)">
                      <b-col>
                        <b-icon-plus-circle-fill></b-icon-plus-circle-fill>
                        {{ GetPermissionText(p) }}
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>

              </b-card-body>
            </b-card>

          </b-col>
        </b-row>

      </b-card-body>
    </b-card>
    <b-modal ref="setPwdModal" title="Sätt lösenord" v-model="setPwdModal" ok-variant="secondary" ok-title="Avbryt"
      ok-only>
      <setpassword @newpassword="SetPwdOkHandler"></setpassword>
    </b-modal>
  </div>
</template>
<script>
import { Api } from "../../lib/api";
import User from "../../lib/user";
import setpassword from "./setpassword";
import userterminal from "./userterminal.vue";

const api = new Api();
const usr = new User();

export default {
  name: "userdetails",
  components: { setpassword, userterminal },
  props: { userid: Number, permissions: Array },
  data() {
    return {
      au: null,
      editMode: false,
      readonly: true,
      setPwdModal: false,
    };
  },
  created() {
    console.log(this.userid);
    this.GetData();
    this.readonly = !usr.HasPermission("ADM");
  },
  watch: {
    userid: () => {
      this.GetData();
    },
  },
  methods: {
    GetData() {
      if (this.userid) {
        console.log(this.party);
        var url = "/api/party/GetUser?id=" + this.userid;
        api.get(url).then((res) => {
          console.log(res);
          this.au = res.data;
        });
      }
    },
    GetPermissionText(permissionId) {
      if (!this.permissions) return "-";
      var x = this.permissions.find((x) => x.PermissionId === permissionId);
      if (x) return x.Description;

      return "[" + permissionId + "]";
    },
    Edit() {
      this.editMode = true;
    },
    CancelEdit() {
      this.editMode = false;
      this.GetData();
    },
    Save() {
      api.post("/api/party/SaveUser", this.au).then((res) => {
        console.log(res.data);
        this.editMode = false;
        this.GetData();
        this.TriggerChange();
      });
    },
    GetPossiblePermissions() {
      var perms = this.permissions.filter(
        (x) =>
          usr.HasPermission(x.MayGrant) &&
          this.au.permissions.indexOf(x.PermissionId) < 0
      );
      var res = perms.map((x) => x.PermissionId);
      return res;
    },
    MayGrant(pid) {
      if (this.permissions) {
        var pm = this.permissions.find((x) => x.PermissionId == pid);
        if (pm) {
          return usr.HasPermission(pm.MayGrant);
        }
      }

      return false;
    },
    AddPermission(p) {
      this.au.permissions.push(p);
    },
    RemovePermission(p) {
      this.au.permissions = this.au.permissions.filter((x) => x != p);
    },
    RemoveUser() {
      if (
        confirm(
          "Ta bort användare " + this.au.username + "? OBS! GÅR EJ ATT ÅNGRA."
        )
      ) {
        api
          .post("/api/party/RemoveUser?id=" + this.au.userid)
          .then((res) => {
            if (res.data) {
              alert(res.data);
            }
            this.readonly = true;
            this.TriggerChange();
            alert("Borttagen!");
            this.$emit('close');
          });
      }
    },
    SetPwd() {
      this.setPwdModal = true;
    },

    SetPwdOkHandler(pwd) {
      if (pwd.length > 0)
        api
          .post("/api/party/SetPwd", { userid: this.au.userid, pwd: pwd })
          .then((res) => {
            if (res.data) {
              alert(res.data);
            }
            if (res.status == 200) {
              alert("Lösenordet har uppdaterats.");
              this.setPwdModal = false;
            }
          });
    },
    TriggerChange() {
      this.$emit("input", this.au);
    },
  },
};
</script>
<style scoped>
.scroll {
  max-height: 500px;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>